import { Chip } from "@mui/material";
import React from "react";
import GaugeChart from "react-gauge-chart";

const chipStyle = {
  color: "#d3f4fe",
  minWidth: '50px',       
};

const AirPollutantKPI = ({avgUtil,maxUtil,minUtil}) => {
  return (
    <>
      <GaugeChart
        id="gauge-chart4"
        animate={false}
        colors={["#f00", "#ffff00","lawngreen"]}
        arcPadding={0.1}
        cornerRadius={4}
        percent={avgUtil!=='N/A'&&(avgUtil>100?1:(avgUtil/100).toFixed(0))} // Max 100
        hideText="true"
        style={{ width: "110px" }}
        className="dashboard-health-title"
      />
      <span>{avgUtil!=='N/A'&&(avgUtil>100?100:avgUtil.toFixed(0))}%</span>
      <p className="card-value">Air Pollutant</p>
      <div className="d-flex flex-column justify-content-start align-items-start gap-2">
        <div className="d-flex justify-content-center align-items-center card-value">
          <Chip label="Max" sx={chipStyle} />
          <p className="m-1 p-0">{maxUtil}</p>
        </div>
        <div className="d-flex justify-content-center card-value">
          <Chip label="Min"  sx={chipStyle}  />
          <p className="m-1 p-0">{minUtil}</p>
        </div>
      </div>
    </>
  );
};

export default AirPollutantKPI;
